import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { errorHandler } from "@helpers/errorHandler";
import { setActive as setActivePortfolio } from "@redux/slices/users/Portfolios";
import { deleteConfirmModal } from "@helpers/DeleteValidate";
import { Call, CallWithFormData, objectToFormData } from "@helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "@redux/actions/administrador/ui/ui";

/* -------------------------------------------------------------------------- */
/*                                   SLICE                                    */
/* -------------------------------------------------------------------------- */

const initialState = {
    active: null,
};

const amortizationsSlice = createSlice({
    name: "amortizations",
    initialState,
    reducers: {
        setActive: (state, action) => {
            state.active = action.payload;
        },
        unsetActive: (state) => {
            state.active = initialState.active;
        },
    },
});

export const { setActive, unsetActive } = amortizationsSlice.actions;
export default amortizationsSlice.reducer;

/* -------------------------------------------------------------------------- */
/*                                  CREATE                                    */
/* -------------------------------------------------------------------------- */

export const startCreateAmortization = (
    investment_id,
    values,
    callback = () => {},
    setErrors = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await CallWithFormData(
            `users/investments/${investment_id}/amortizations/create`,
            "POST",
            objectToFormData(values)
        );

        if (resp.success) {
            Swal.fire({
                title: "Guardado",
                text: "La amortización fue creada correctamente.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 5000,
            });

            callback();
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

/* -------------------------------------------------------------------------- */
/*                                  UPDATE                                    */
/* -------------------------------------------------------------------------- */

export const startUpdateAmortization = (
    investment_id,
    amortization_id,
    values,
    callback = () => {},
    setErrors = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await CallWithFormData(
            `users/investments/${investment_id}/amortizations/edit/${amortization_id}`,
            "POST",
            objectToFormData(values)
        );

        if (resp.success) {
            Swal.fire({
                title: "Actualizado",
                text: "La amortización fue actualizada.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 5000,
            });

            callback();
        } else {
            setErrors(resp.errors || {});
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

/* -------------------------------------------------------------------------- */
/*                                  DELETE                                    */
/* -------------------------------------------------------------------------- */

export const startDeleteAmortization = (
    investment_id,
    amortization_id,
    callback = () => {}
) => {
    return async (dispatch) => {
        await deleteConfirmModal(async () => {
            dispatch(startUILoading());

            const resp = await Call(
                `users/investments/${investment_id}/amortizations/delete/${amortization_id}`,
                "DELETE"
            );

            if (resp.success) {
                Swal.fire({
                    title: "Eliminado",
                    text: "La amortización fue eliminada.",
                    icon: "success",
                    toast: true,
                    position: "bottom-end",
                    timer: 5000,
                });

                callback();
            } else {
                errorHandler(resp);
            }

            dispatch(stopUILoading());
        });
    };
};
